module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return (_vm.microNote) ? _vm._c('div', [_vm._c('div', {
    staticClass: "panel-body",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.handleClick($event)
      }
    }
  }, [_vm._c('div', {
    staticClass: "microNoteImageStudier"
  }, [_vm._c('div', {
    staticClass: "image-container"
  }, [_vm._l((_vm.keywords), function(keyword) {
    return _vm._c('ImageKeyword', {
      attrs: {
        "scale": _vm.scale,
        "keywordId": keyword.id
      }
    })
  }), _vm._v(" "), (_vm.microNote.micro_note_images) ? _vm._c('img', {
    ref: "image",
    attrs: {
      "src": _vm.microNote.micro_note_images[0].image_url
    }
  }) : _vm._e()], 2)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a74f5b22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter-studier/MicroNoteImageStudier.vue
// module id = 703
// module chunks = 1